// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-home-home-section-message----home-section-message-module---wrapper---3iW40","copy":"src-components-home-home-section-message----home-section-message-module---copy---buQpz","white":"src-components-home-home-section-message----home-section-message-module---white---2kbiM","break":"src-components-home-home-section-message----home-section-message-module---break---36GBg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/home/home-section-message/home-section-message.module.css
// module id = 495
// module chunks = 35783957827783